/**
 * Lightweight VideoContext shell - no Stream SDK import.
 * Used for initial render so we can defer loading the full ~640KB Stream SDK
 * until user navigates to /messages (video calls).
 */
import React, { createContext, useContext, ReactNode } from 'react';

export interface VideoContextValue {
  client: unknown;
  isInitialized: boolean;
}

export const defaultVideoContextValue: VideoContextValue = {
  client: null,
  isInitialized: false,
};

export const VideoContext = createContext<VideoContextValue>(defaultVideoContextValue);

export function useVideoContext(): VideoContextValue {
  return useContext(VideoContext);
}

export function VideoContextShell({ children }: { children: ReactNode }) {
  return (
    <VideoContext.Provider value={defaultVideoContextValue}>
      {children}
    </VideoContext.Provider>
  );
}
